var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCurrentBalance = function SvgCurrentBalance(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCF1\\u2705-Investments-(I)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investment-switch---Accum---Current-investment-switch---D01",
    transform: "translate(-128.000000, -508.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(104.000000, 463.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(24.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFF0E0",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Quick-Actions/Investment-Change-Current-Balance---Scales",
    transform: "translate(8.000000, 8.000000)",
    fill: "#FF8200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,3 L3.612,4.836 C3.918,5.755125 4.778625,6.375 5.74725,6.375 L10.875,6.375 L10.875,8.715 C7.060125,9.26175 4.125,12.53325 4.125,16.5 L4.125,19.875 C4.125,20.496 4.629,21 5.25,21 L18.75,21 C19.371,21 19.875,20.496 19.875,19.875 L19.875,16.5 C19.875,12.53325 16.939875,9.26175 13.125,8.715 L13.125,6.375 L18.25275,6.375 C19.221375,6.375 20.080875,5.755125 20.386875,4.836 L21,3 L3,3 Z M14.25,15.375 C14.25,16.618125 13.243125,17.625 12,17.625 C10.756875,17.625 9.75,16.618125 9.75,15.375 C9.75,14.131875 10.756875,13.125 12,13.125 C13.243125,13.125 14.25,14.131875 14.25,15.375 Z",
    id: "Shape"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCurrentBalance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/current-balance.40c0ba795c0ae5361e0d83f6239748d7.svg";